import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosError } from 'axios';

export const createApiClient = (getHeaders: () => Record<string, string>): AxiosInstance => {
  const instance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
  });

  // Request interceptor
  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // Add headers
      const headers = getHeaders();
      Object.entries(headers).forEach(([key, value]) => {
        config.headers.set(key, value);
      });

      // Add domain parameters
      // Use VITE_DOMAIN if set (for local dev), otherwise use window.location.origin
      const domain = import.meta.env.VITE_DOMAIN || window.location.origin;

      if (config.method?.toUpperCase() === 'GET') {
        config.params = {
          ...(config.params || {}),
          domain,
          domainName: domain,
        };
      } else {
        config.data = {
          ...(config.data || {}),
          domain,
          domainName: domain,
        };
      }

      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      // Handle 401 Unauthorized
      if (error.response?.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
